<template>
    <div class="section" id="section-ressources">
        <div class="section-content">
            <div v-if="!loaded" class="container_preload">
                <div class="roulette"></div>
            </div>

            <template v-else-if="loaded">
                <div class="section-content-banner">
                    <div>R&Eacute;F&Eacute;RENCES</div>
                    <div class="text" v-html="chapo"></div>
                    <div class="tools">
                        <div>TRIER PAR&nbsp;:</div>
                        <div class="option">
                            <input type="radio" id="auteur" value="auteur" v-model="tri">
                            <label for="auteur">AUTEUR</label>
                        </div>
                        <div class="option">
                            <input type="radio" id="theme" value="theme" v-model="tri">
                            <label for="theme">THÈME</label>
                        </div>
                    </div>
                    <div class="closer fermer" @click="closeFooter()">╳</div>
                </div>
                <div class="section-content-loaded">
                    <div>
                        <template v-if="tri == 'auteur'">
                            <div class="sorted-authors">
                                <ul class="ressources">
                                    <li class="ressource" v-for="(ressource, index) in ressources" :key="index" v-html="ressource.ressource"></li>
                                </ul>
                            </div>
                        </template>
                        <template v-else-if="tri == 'theme'">
                            <div class="sorted-themes" v-for="theme in themes" :key="theme.slug">
                                <span class="souligne">{{ theme.nom }}</span>
                                <ul class="ressources" v-if="theme.ressources.length > 0">
                                    <li class="ressource" v-for="(ressource, index) in theme.ressources" :key="index" v-html="ressource.ressource">
                                    </li>
                                </ul>
                            </div>
                        </template>
                    </div>
                </div>
                </template>
            </div>
        </div>
    </div>

    <!-- <div class="contenu_volet_bas">
        
        <div v-if="!loaded" class="container_preload">
            <div class="roulette"></div>
        </div>

        <template v-else-if="loaded">

            <div class="chapo" v-html="chapo"></div>
            <hr>

            <div class="tri_ressources">TRIER PAR&nbsp;:
                <div class="option">
                    <input type="radio" id="auteur" value="auteur" v-model="tri">
                    <label for="auteur">AUTEUR</label>
                </div>
                <div class="option">
                    <input type="radio" id="theme" value="theme" v-model="tri">
                    <label for="theme">THÈME</label>
                </div>
            </div>
    
            <template v-if="tri == 'auteur'">
                <br>
                <ul class="ressources">
                    <li class="ressource" v-for="(ressource, index) in ressources" :key="index" v-html="ressource.ressource">
                    </li>
                </ul>
            </template>
    
            <template v-else-if="tri == 'theme'">
                <div class="theme" v-for="theme in themes" :key="theme.slug">
                    <br><br>
                    <span class="souligne">{{ theme.nom }}</span>
                    <ul class="ressources" v-if="theme.ressources.length > 0">
                        <li class="ressource" v-for="(ressource, index) in theme.ressources" :key="index" v-html="ressource.ressource">
                        </li>
                    </ul>
                </div>
            </template>
        </template>
    </div> -->
</template>

<script>
import { url_annexes } from '../../variables.js';

export default {
    data() {
        return {
            loaded: false,
            ressources: [],
            themes: [],
            chapo: "",
            tri:"auteur"
        }
    },
    computed: {

        // ressources_par_themes: function() {
        //     var liste_ressources = Object.values(this.ressources);
        //     var tri, ordre;

        //     for (var i = 0; i < this.colonnes.length; i++) {
        //         let colonne = this.colonnes[i];
        //         if (colonne.tri == "actif") {
        //             tri = colonne.slug;
        //             ordre = colonne.ordre;
        //             break;
        //         }
        //     }
        //     liste_fiches = _.orderBy(liste_fiches, tri, ordre);
        //     return liste_fiches;
        // }
        // ressources_alpha: function() {
        //     var liste_ressources = Object.values(this.ressources);
        //     var tri, ordre;

        //     for (var i = 0; i < this.colonnes.length; i++) {
        //         let colonne = this.colonnes[i];
        //         if (colonne.tri == "actif") {
        //             tri = colonne.slug;
        //             ordre = colonne.ordre;
        //             break;
        //         }
        //     }
        //     liste_fiches = _.orderBy(liste_fiches, colonne.slug, );
        //     return liste_fiches;
        // }
    },

    mounted: function() {
        this.axios.get(url_annexes + "ressources").then((response) => {

            function removeTags(str) {
                if ((str===null) || (str===''))
                    return false;
                else
                    str = str.toString();
                return str.replace( /(<([^>]+)>)/ig, '');
            }


            response.data.ressources.sort(function(a, b) {
              var keyA = removeTags(a.ressource),
                keyB = removeTags(b.ressource);
              if (keyA < keyB) return -1;
              if (keyA > keyB) return 1;
              return 0;
            });


            this.ressources = response.data.ressources;
            this.themes = response.data.themes;
            this.chapo = response.data.chapo;

            for (var i=0; i<this.themes.length; i++) {
                let theme =  this.themes[i];
                theme.ressources = [];

                for (var j=0; j<this.ressources.length; j++) {
                    let ressource = this.ressources[j];
                    if (ressource.theme == theme.slug) {
                        theme.ressources.push(ressource);
                    }
                }
            }

            this.loaded = true;
        });
    },
    methods : {
        closeFooter(){
            //console.log(this);
            document.body.setAttribute("data-footer",false);
            document.body.setAttribute("data-mode","");
        }
    }
};
</script>
<style>


/*ul.ressources {
    margin-top:1em;
    list-style-type:disc;
    overflow: auto;
    padding-top:0px;
    padding-bottom:0px;
    padding-right:0px;
    padding-left:1rem;
}

li.ressource {
    margin-bottom:1em;
    display: list-item;
}
*/

.option {
    display: inline-block;
    margin-left: 39px;
}

.option, label {
    cursor:pointer;
}


input[type="radio"] {
  display: none;
}
input[type="radio"] + label {
  position: relative;
  padding-left: 1.5rem;
}
input[type="radio"] + label::before,
input[type="radio"] + label::after {
    transform: translateY(-3px);
    display: block;
    position: absolute;
    box-sizing: border-box;
    bottom: 0;
    left: 0;
    content:'';
    bottom:-0.1rem;
    width: 1rem;
    height: 1rem; 
    border-radius: 1rem;
}
input[type="radio"] + label::before {
  border: 2px solid black;
}
input[type="radio"]:checked + label::after {
  background-color: black;
}

/*jdb*/
.sorted-themes, .sorted-authors{
    padding-top: calc(var(--interlignage-courant) * 3);
}
.tools{
    display: flex;
    flex-direction: row;
    justify-content: flex-start;
    align-items: flex-start;
    margin-top: 9px;
    width: 100%;
}
ul.ressources {
    /*margin-top:1em;
    list-style-type:disc;
    overflow: auto;
    padding-top:0px;
    padding-bottom:0px;
    padding-right:0px;
    padding-left:1rem;*/
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    grid-column-gap: 39px;
    grid-row-gap: calc(var(--interlignage-courant));
    list-style: none;
}
.souligne{
    display: table;
    margin-bottom: 39px;
}

li.ressource {
    /*margin-bottom:1em;
    display: list-item;*/
}
</style>